import { get_token} from "@/router";
import Navbar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue"
import PortalMembers from "@/components/PortalMembers/PortalMembers.vue";
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"

export default {
    components: {
        Navbar,
        AllPortals,
        CreateFeed,
        PortalMembers,
        PortalRequest,
        SurveyView,
        DocumentApproval,
        DocumentWarehouse,
        ReportCommentModal,
        StickyNav
    },
    data() {
        return {
            reports: [],
            expandedReports: [],
            current_date: this.get_formatted_date(),
            activeVoiceTab: 'your_feed',
            comment_modal_visible: false,
            user_id:null,
           
        };
    },
    mounted() {
        this.filterReports();
        this.user_id = this.get_user_id();
        this.token_exists = get_token();
    },
    methods: {
      getToken() {
        return get_token();
      },
        get_formatted_date() {
         const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
         return new Date().toLocaleDateString('en-GB', options);
        }, 
        getIdFromURL(param) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        },
        filterReports() {
            const portalId = this.$route.params.portal_id;
            const report_id = this.$route.params.report_id;

            const payload = {
                filter_values: {
                    portal_id: portalId,
                    id: report_id
                }
            };

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_reports_api/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),
                success: (response) => {
                    if (response.status === "success") {
                        this.reports = Array.isArray(response.data.report_data) ? response.data.report_data : [];

                        this.reports.forEach(report => {
                        if (report?.id) {
                            // Check for associated profile files
                            if (Array.isArray(report.report_files) && report.report_files.length > 0) {
                            const firstFile = report.report_files[0];
                            report.pdf_file_url = firstFile?.file_url || ''; // Add to the specific report object
                            report.pdf_file = firstFile || {};
                            report.file_name = firstFile?.name || '';
                            } else {
                            // Reset file properties on the report
                            report.pdf_file_url = '';
                            report.pdf_file = null;
                            report.file_name = '';
                            }
                        }
                        });
                        const reportId = this.getIdFromURL('report_id');
                        if (reportId) {
                        const selectedReport = this.reports.find(r => r.id === parseInt(reportId, 10));
                        if (selectedReport) {
                            this.display_comment_modal(selectedReport);
                        }
                        }
                    } else {
                        console.error("Error fetching reports:", response.message);
                    }
                },
                error: (error) => {
                    console.error("AJAX error:", error);
                }
            });
        },
        baseUrl(post, type) {
            const baseUrl = `${window.location.origin}${this.$route.path}`;
            // Dynamically build the URL based on the type (either 'hub' or 'report')
            if (type === 'exchange_hub') {
            return `${baseUrl}?hub_id=${post.id}`;
            } else if (type === 'report') {
            return `${baseUrl}?report_id=${post.id}`;
            }
            return baseUrl
        },
        copyReportLinkToClipboard(report) {
        const link = this.baseUrl(report, 'report');
        navigator.clipboard.writeText(link).then(() => {
            this.showToast('Link copied to clipboard!');
        })
        },
        display_comment_modal(report_data) {
        this.report_data = report_data;
        this.comment_modal_visible = true;
        },
        hide_comment_comment() {
        this.report_data = {};
        this.comment_modal_visible = false;
        },
        likeReport(report) {
        if (!this.token_exists) {
            this.$router.push('/sign_in_finale');
            return;
        }
        const reportId = report.id;
        $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
            contentType: "application/json",
            headers: {
            'Authorization': `Token ${this.getToken()}`,
            },
            data: JSON.stringify({ report_id: reportId }),
            success: (response) => {
            if (response.status === "success") {

            const liked_report = this.reports.find(like => like.id === reportId);
            if (liked_report) {
                liked_report.like_count++;
            }
                const likeButton = document.getElementById(`like-button${reportId}`);
                const likedButton = document.getElementById(`liked-button${reportId}`);


                if (likeButton) {
                likeButton.classList.add('d-none');
                }

                if (likedButton) {
                likedButton.classList.remove('d-none');
                }
            }
        }
      });
        },
        unlikeReport(report) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const likeButton = document.getElementById(`like-button${reportId}`);
            const likedButton = document.getElementById(`liked-button${reportId}`);

          const unliked_report = this.reports.find(like => like.id === report.id);
          if (unliked_report) {
            unliked_report.like_count--;
          }

            if (likeButton) {
              likeButton.classList.remove('d-none');
            }

            if (likedButton) {
              likedButton.classList.add('d-none');
            }
          }
        }
      });
    },
     get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
      copyReportLinkToClipboard(report) {
      const link = this.baseUrl(report, 'report');
      navigator.clipboard.writeText(link).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
    document.querySelector('#copyToast .toast-body').textContent = message;

    $('#copyToast').fadeIn(300).addClass('show');
    setTimeout(function() {
      $('#copyToast').fadeOut(300).removeClass('show');
    }, 3000); 
  },
  closeMenu(reportId) {
    const checkbox = document.getElementById('menu-open-' + reportId);
    if (checkbox) {
      checkbox.checked = false;
    }
  },
  getFileIcon(fileUrl) {
    if (fileUrl.includes('.pdf')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337946.png'; // PDF icon
    if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337932.png'; // Word icon
    if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337958.png'; // Excel icon
    if (fileUrl.includes('.ppt') || fileUrl.includes('.pptx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337950.png'; // PowerPoint icon
    if (fileUrl.includes('.html') || fileUrl.includes('.htm')) 
      return 'https://cdn-icons-png.flaticon.com/128/732/732212.png'; // HTML icon
    return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
  },
  getFileName(fileUrl) {
    const decodedUrl = decodeURIComponent(fileUrl);
    const cleanUrl = decodedUrl.split('?')[0];
    return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
  },  
    },
}